import ReactYouTube from 'react-youtube';

export const YouTube = ReactYouTube;